export const LenCategories = () => {
  return [ "електроніка", "ювелірні вироби", "чоловічий одяг", "жіночий одяг"];
};
